import React from 'react';
import gravatar from '../../../assets/images/gravatar.png'
export default function dealstreetHelicap(){
  return(
   <div className="post-1536 post type-post status-publish format-standard hentry category-news dealstreetHelicap">
<div className="blog-single-post nosidebar">

  <section className="subpage-banner"></section>

  <div className="container">

    <div className="row">

      <div className="col-sm-12">
        <div className="row">
          <div className="col-sm-2">
                      
            <img src={gravatar} className="author-avatar img-circle img-responsive" alt="Avatar" />            
                                  

          </div>          

          <div className="col-sm-10">

            <h2 className="post-title">Fintech startup Helicap raises $1.5m seed round led by former SG minister</h2>
            <div className="row meta-info">
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-clock"></i>2 May 2018</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-comments"></i>No Comments</span></div>
              <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-eye"></i>104 Views</span></div>
                            <div className="col-sm-6 col-md-3 info"><span><i className="fa fa-tag"></i><a href="/news/" rel="category tag">News</a></span></div>
                          </div>

            <div className="post-article"><p>Read More @ https://www.dealstreetasia.com/stories/helicap-singapore-97065/</p>
<p>Fintech startup Helicap has announced the closing of a seed funding round of $1.5 million led by Singapore’s former Minister of State and the Chairman of Nufin Data, Teo Ser Luck. </p>
</div>

            <hr></hr>
            
            <div className="social-share">
              <div className="row">
                <div className="col-xs-6 share-text">Share</div>
                <div className="col-xs-6 share-button">
                  <div className="btn-group">
                    <a href="https://www.facebook.com/sharer/sharer.php?u=https://33-capital.com/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-facebook"></i></a>
                    <a href="https://plus.google.com/share?url=https://33-capital.com/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-gplus"></i></a>
                    <a href="https://twitter.com/intent/tweet?text=Fintech startup Helicap raises $1.5m seed round led by former SG minister&amp;url=https://33-capital.com/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-twitter"></i></a>
                    <a href="https://www.linkedin.com/shareArticle?mini=true&amp;url=https://33-capital.com/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/&amp;title=Fintech startup Helicap raises $1.5m seed round led by former SG minister&amp;summary=Read More @ https://www.dealstreetasia.com/stories/helicap-singapore-97065/ Fintech startup Helicap has announced the closing of a seed funding round of $1.5 million led by Singapore’s former Minister of State and the Chairman of Nufin Data, Teo Ser Luck.&amp;source=https://33-capital.com/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-linkedin"></i></a>
                    <a href="https://pinterest.com/pin/create/button/?url=https://33-capital.com/fintech-startup-helicap-raises-1-5m-seed-round-led-by-former-sg-minister/&amp;description=Read More @ https://www.dealstreetasia.com/stories/helicap-singapore-97065/ Fintech startup Helicap has announced the closing of a seed funding round of $1.5 million led by Singapore’s former Minister of State and the Chairman of Nufin Data, Teo Ser Luck.&amp;media=" className="btn btn-default" target="_blank" rel="noopener noreferrer"><i className="icon-pinterest"></i></a>
                  </div>                  
                </div>
              </div>
            </div>  
            <hr></hr>
                        <div className="comment-count">
              No Comments           </div>
            <hr></hr>
                        
          </div>
        
        </div>
        
      
      </div>

  

    </div>

  </div>

</div>
</div>

  )
}



// WEBPACK FOOTER //
// ./src/components/News/posts/dealstreet_helicap.js